<template>
  <b-card
    title="Ajouter un Gouvernorat"
    aria-label="Formulaire d’ajout de gouvernorat"
  >
    <b-card-text>
      <span>Veuillez saisir le nom officiel du gouvernorat. Ce champ est obligatoire.</span>
    </b-card-text>

    <!-- form -->
    <validation-observer ref="simpleRules">
      <b-form
        aria-label="Formulaire d’ajout de gouvernorat"
        aria-describedby="gov-create-desc"
      >
        <span
          id="gov-create-desc"
          class="sr-only"
        >Remplissez le champ pour ajouter un nouveau gouvernorat. Utilisez une désignation officielle et unique.</span>
        <b-row>
          <b-col md="12">
            <b-form-group
              label="Nom du gouvernorat "
              label-for="governorate-name"
              label-class="font-weight-bold"
              description="Nom officiel du gouvernorat. Ce champ est obligatoire."
            >
              <span
                class="text-danger"
                aria-hidden="true"
              >*</span>
              <validation-provider
                #default="{ errors }"
                name="Gouvernorat"
                rules="required"
              >
                <b-form-input
                  id="governorate-name"
                  v-model="governorate.name"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Nom du gouvernorat"
                  aria-required="true"
                  :aria-invalid="errors.length > 0 ? 'true' : 'false'"
                  aria-describedby="gov-name-desc"
                />
                <b-form-text
                  id="gov-name-desc"
                  class="sr-only"
                >
                  Saisissez le nom officiel du gouvernorat. Ce champ est obligatoire.
                </b-form-text>
                <small
                  v-if="errors[0]"
                  class="text-danger"
                  role="alert"
                >{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              :class="{ 'disabled-cursor': isLoading || !isGovernorateValid }"
              :disabled="isLoading || !isGovernorateValid"
              aria-label="Ajouter le gouvernorat"
              @click.prevent="addGovernorate"
            >
              Ajouter
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BCardText,
  BFormText,
} from 'bootstrap-vue'
import { required } from '@validations'
import axios from 'axios'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BCardText,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormText,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      governorate: {
        name: '',
      },
      required,
      isLoading: false,
    }
  },
  computed: {
    isGovernorateValid() {
      return (
        this.governorate.name !== ''
      )
    },
  },
  methods: {
    async addGovernorate() {
      const success = await this.$refs.simpleRules.validate()
      if (success) {
        try {
          this.isLoading = true
          await axios.post(
            '/api/governorates/create/',
            {
              name: this.governorate.name,
            },
          )
          this.isLoading = false
          setTimeout(() => {
            this.showToast('success', 'top-center', 'Gouvernorat ajouté avec succés')
          }, 1000)
          this.$router.push('/governorates/')
        } catch (error) {
          setTimeout(() => {
            this.showToast('danger', 'top-center', error.toString())
          }, 1000)
        }
      } else {
        setTimeout(() => {
          this.showToast('danger', 'top-center', 'champ obligatoire ! vérifier votre donnée !')
        }, 1000)
      }
    },

    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
